/**
 * True when the running bundle is older than the deployed one. A deploy can
 * change routes and auth in ways that make the old client's requests fail, so
 * a reload is the correct recovery rather than an error screen.
 */
export async function isClientStale(): Promise<boolean> {
  if (__APP_VERSION__ === "development") return false
  try {
    const response = await fetch(`/version.json?_t=${Date.now()}`)
    const data: { version: string } = await response.json()
    return data.version !== __APP_VERSION__
  } catch {
    return false
  }
}
